import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { NSUrlsConstants } from '@ruby/configs/urls.constants';
import { ICarTrafficSummary } from '@ruby/shared/models/car-traffic/car-traffic.interface';

@Injectable({
  providedIn: 'root'
})
export class TrafficHistoryService {

  constructor(private http: HttpClient) {
  }

  /**
   * Get Car Traffic History Three year summary list
   *
   * @summary Gets Traffic history 3 year summary
   * @param customerNumber: string
   * @returns Observable<Array<ICarTrafficSummary> | never>
   */
  get3YearsTrafficHistory(customerNumber: string): Observable<Array<ICarTrafficSummary> | never> {
    return this.http.get(
      NSUrlsConstants.carTraffic3YearsUrl,
      { params: new HttpParams().set('customerNumber', customerNumber) }
    ).pipe(map(response => response as Array<ICarTrafficSummary>));
  }
}
